<template>
  <div class="hot-main" v-infinite-scroll="loadMore" infinite-scroll-disabled="scrollDisabled" infinite-scroll-immediate-check="false">
    <div v-for="(item, index) in dataList" :key="item.ProductID" :class="!item.platformWithoutGoods ? 'shopCard' : ''">
      <template v-if="!item.platformWithoutGoods">
        <div class="hot-block" v-if="index % 2 === 0" :key="item.ProductID">
          <div class="cnt-list-item">
            <div @click="entoDetailPage(item, index)" @touchstart="itemTouchStart(index)">
              <div class="item-img">
                <!-- <img v-lazy="item.ShowPicUrl + '!sohoUpyun'" alt="" :key="item.ProductID" v-if="!item.isUnsearch"/> -->
                <img v-if="!item.isUnsearch" v-lazy="item.ShowPicUrl" :data-srcset="item.ShowPicUrl | compressImgUrl" alt="" :key="item.ProductID" />
                <img v-lazy="item.ProductHeadUrl" alt="" :key="item.NumId" v-else />
                <div class="soldout-mask" v-if="!item.IsStockNoZero && !item.isUnsearch">
                  <p>Sorry</p>
                  <p>抢光啦</p>
                </div>
              </div>
              <div class="item-title twoRow">
                <div class="txt">
                  <span class="icon-tm" v-if="item.isUnsearch && item.UserType === 1">天猫</span>
                  <template v-if="!item.isUnsearch">
                    <!-- <span
                      class="platform-tag tm"
                      v-if="item.ShopType.toLocaleUpperCase() === 'B'"
                      >天猫</span
                    >
                    <span
                      class="platform-tag pdd"
                      v-if="item.ShopType.toLocaleUpperCase() === 'P'"
                      >拼多多</span
                    >
                    <span
                      class="platform-tag jd"
                      v-if="item.ShopType.toLocaleUpperCase() === 'J'"
                      >京东</span
                    > -->
                    <plat-formLogo :shopType="item.ShopType.toLocaleUpperCase()"></plat-formLogo>
                  </template>
                  <template>{{ item.isUnsearch ? item.ProductName : item.TitleShort }}</template>
                </div>
              </div>
              <div class="item-price">
                <div class="i-price">
                  <template v-if="!item.isUnsearch">
                    <div class="l-prod-price">
                      <div class="price">
                        <div class="yuan">￥</div>
                        <div class="money">
                          {{ item.FreeCardNum !== null ? 0 : item.SaleDiscountPrice }}
                        </div>
                      </div>
                      <div class="through">￥{{ item.ProductPrice }}</div>
                    </div>
                    <div class="item-tag">
                      <div class="l-freecard-tag" v-if="!item.isUnsearch && item.FreeCardNum !== null">
                        <span>免单卡</span>
                        <span>{{ isNewcomer ? 1 : item.FreeCardNum }}</span>
                      </div>
                      <div class="l-rebate-tag">
                        <span class="t">返利</span>
                        <span class="rmb" v-if="item.FreeCardNum !== null">￥{{ item.ProductPrice }}</span>
                        <span class="rmb" v-else-if="item.BuyRebatePrice">￥{{ item.BuyRebatePrice }}</span>
                      </div>
                    </div>
                  </template>
                  <!-- 免搜价格 -->
                  <template v-else>
                    <div class="i-discount flex">
                      <div class="unsearch-through flex">￥{{ item.ProductPrice }}</div>
                      <div class="unsearch_coupons">券{{ item.CouponAmount | filterCoupon }}元</div>
                    </div>
                    <div class="unserch-p flex">
                      <i class="unserch-yuan">￥</i>
                      <span class="unserch-money">{{ item.RealAmount }}</span>
                    </div>
                  </template>
                </div>
              </div>
              <!-- 免搜 -->
              <!-- <div class="un-search-tip" v-if="item.isUnsearch">免搜</div> -->
            </div>
            <!-- 收藏图标 -->
            <!-- <div
                  v-if="!item.isUnsearch && !item.IsStockNoZero"
                  :class="{'remind-icon': true, 'active': item.IsFavorite}"
                  @click="remindClick(item.ProductID, item.IsFavorite, index)">
                    <i class="icon iconfont icon-shoucang"></i>
                </div> -->
            <!-- icon -->
            <div class="more-icon" @click="moreIconClick(index)" v-if="!item.isUnsearch">
              <i class="icon iconfont icon-yuandiancaidan"></i>
            </div>
            <!-- 屏蔽层 -->
            <div v-if="item.operateMaskShow" class="operate-mask opacity-anim" @click.self="item.operateMaskShow = false">
              <div class="operate-icon" @click="remindClick(item.ProductID, item.IsFavorite, index)">
                <template v-if="!item.IsFavorite">
                  <i class="iconfont icon-icon-test1"></i>
                  <span>收藏</span>
                </template>
                <span v-else>取消<br />收藏</span>
              </div>
            </div>
            <!-- 屏蔽层end -->
          </div>
        </div>
        <div class="hot-block" v-if="index % 2 === 1" :key="item.ProductID">
          <div class="cnt-list-item">
            <div @click="entoDetailPage(item, index)" @touchstart="itemTouchStart(index)">
              <div class="item-img">
                <!-- <img v-lazy="item.ShowPicUrl + '!sohoUpyun'" alt="" :key="item.ProductID" v-if="!item.isUnsearch"/> -->
                <img v-if="!item.isUnsearch" v-lazy="item.ShowPicUrl" :data-srcset="item.ShowPicUrl | compressImgUrl" alt="" :key="item.ProductID" />
                <img v-lazy="item.ProductHeadUrl" alt="" :key="item.NumId" v-else />
                <div class="soldout-mask" v-if="!item.IsStockNoZero && !item.isUnsearch">
                  <p>Sorry</p>
                  <p>抢光啦</p>
                </div>
              </div>
              <div class="item-title twoRow">
                <div class="txt">
                  <span class="icon-tm" v-if="item.isUnsearch && item.UserType === 1">天猫</span>
                  <template v-if="!item.isUnsearch">
                    <!-- <span
                      class="platform-tag tm"
                      v-if="item.ShopType.toLocaleUpperCase() === 'B'"
                      >天猫</span
                    >
                    <span
                      class="platform-tag pdd"
                      v-if="item.ShopType.toLocaleUpperCase() === 'P'"
                      >拼多多</span
                    >
                    <span
                      class="platform-tag jd"
                      v-if="item.ShopType.toLocaleUpperCase() === 'J'"
                      >京东</span
                    > -->
                    <plat-formLogo :shopType="item.ShopType.toLocaleUpperCase()"></plat-formLogo>
                  </template>
                  <template>{{ item.isUnsearch ? item.ProductName : item.TitleShort }}</template>
                </div>
              </div>
              <div class="item-price">
                <div class="i-price">
                  <template v-if="!item.isUnsearch">
                    <div class="l-prod-price">
                      <div class="price">
                        <div class="yuan">￥</div>
                        <div class="money">
                          {{ item.FreeCardNum !== null ? 0 : item.SaleDiscountPrice }}
                        </div>
                      </div>
                      <div class="through">￥{{ item.ProductPrice }}</div>
                    </div>
                    <div class="item-tag">
                      <div class="l-freecard-tag" v-if="!item.isUnsearch && item.FreeCardNum !== null">
                        <span>免单卡</span>
                        <span>{{ isNewcomer ? 1 : item.FreeCardNum }}</span>
                      </div>
                      <div class="l-rebate-tag">
                        <span class="t">返利</span>
                        <span class="rmb" v-if="item.FreeCardNum !== null">￥{{ item.ProductPrice }}</span>
                        <span class="rmb" v-else-if="item.BuyRebatePrice">￥{{ item.BuyRebatePrice }}</span>
                      </div>
                    </div>
                  </template>
                  <!-- 免搜价格 -->
                  <template v-else>
                    <div class="i-discount flex">
                      <div class="unsearch-through flex">￥{{ item.ProductPrice }}</div>
                      <div class="unsearch_coupons">券{{ item.CouponAmount | filterCoupon }}元</div>
                    </div>
                    <div class="unserch-p flex">
                      <i class="unserch-yuan">￥</i>
                      <span class="unserch-money">{{ item.RealAmount }}</span>
                    </div>
                  </template>
                </div>
              </div>
              <!-- 免搜 -->
              <!-- <div class="un-search-tip" v-if="item.isUnsearch">免搜</div> -->
            </div>
            <!-- icon -->
            <div class="more-icon" @click="moreIconClick(index)" v-if="!item.isUnsearch">
              <i class="icon iconfont icon-yuandiancaidan"></i>
            </div>
            <!-- 屏蔽层 -->
            <div v-if="item.operateMaskShow" class="operate-mask opacity-anim" @click.self="item.operateMaskShow = false">
              <div class="operate-icon" @click="remindClick(item.ProductID, item.IsFavorite, index)">
                <template v-if="!item.IsFavorite">
                  <i class="iconfont icon-icon-test1"></i>
                  <span>收藏</span>
                </template>
                <span v-else>取消<br />收藏</span>
              </div>
            </div>
            <!-- 屏蔽层end -->
          </div>
        </div>
      </template>
      <template v-else>
        <!-- 平台无商品 -->
        <div class="plat-without" :key="index">
          <div class="iconfont icon-dengpao"></div>
          <div v-if="item.isFirstNull">
            平台暂无相关宝贝，以下为可领券的免搜商品~
          </div>
          <div v-else>
            平台没有更多的相关宝贝了，以下为可领券的免搜商品，快来看看吧~
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { ProductFavoriteAdd, IsSetRemind } from '@/api/remind'
import { IsExistTaskCanAccept } from '@/api/souhuo'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      // 提醒设置
      isSetting: false,
      curOperateIndex: null
    }
  },
  computed: {
    ...mapGetters(['loginState', 'getIsApp', 'getIsAuthorized'])
  },
  props: {
    dataList: {
      type: Array,
      require: true,
      default: function() {
        return []
      }
    },
    // 是否是新人
    isNewcomer: {
      type: Boolean,
      default: false
    },
    scrollDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations(['AUTHORIZE_POPUP_SHOW']),
    loadMore() {
      this.$emit('loadMore')
    },
    entoDetailPage(item, index) {
      if (item.isUnsearch) {
        this.$emit('entoUnSearchDetailPage', index)
      } else {
        let isFreeCard = false
        if (item.FreeCardNum !== null) isFreeCard = true
        // this.$emit('entoDetailPage', item.ProductID, item.IsStockNoZero, isFreeCard)
        // 存在库存并且已登录的情况
        if (item.IsStockNoZero && this.$store.getters.loginState) {
          Indicator.open({
            text: '加载中',
            spinnerType: 'triple-bounce'
          })
          // 进入前 再次检测是否存在库存
          IsExistTaskCanAccept({ productID: item.ProductID })
            .then((res) => {
              Indicator.close()
              if (res.Msg !== 'False') {
                this.$emit('entoDetailPage', item.ProductID, isFreeCard)
              } else {
                // 主图变更为被抢光
                this.picAddNoStock(index)
              }
            })
            .catch((res) => {
              Indicator.close()
              if (res.ErrMsg) {
                Toast(res.ErrMsg)
              }
            })
          // 无库存，未登录
        } else {
          this.$emit('entoDetailPage', item.ProductID, isFreeCard)
        }
      }
    },
    // 点击其它地方时，关闭上个屏蔽层
    itemTouchStart(index) {
      if (this.curOperateIndex === null) return
      if (this.curOperateIndex !== index && this.dataList[this.curOperateIndex] && this.dataList[this.curOperateIndex].operateMaskShow !== undefined) {
        this.dataList[this.curOperateIndex].operateMaskShow = false
      }
    },
    picAddNoStock(index) {
      Toast('商品已经被抢光啦')
      this.$set(this.dataList[index], 'IsStockNoZero', false)
    },
    async moreIconClick(index) {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (!this.loginState) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.itemTouchStart(index)
      this.curOperateIndex = index
      const indexIsFavorite = await this.$utils.IsFavorite({
        productId: this.dataList[index].ProductID
      })
      this.$set(this.dataList[index], 'IsFavorite', indexIsFavorite)
      this.$set(this.dataList[index], 'operateMaskShow', true)
    },
    // 添加收藏夹/移出收藏夹
    remindClick(productID, isBuyRemind, index) {
      this.dataList[index].operateMaskShow = false
      if (!this.$store.getters.loginState) {
        this.$emit('unLogin')
        return
      }
      if (this.isSetting) return
      this.isSetting = true
      if (isBuyRemind) {
        // 已设置，点击移出
        Indicator.open({
          text: '移出中',
          spinnerType: 'triple-bounce'
        })
        IsSetRemind({ productId: productID })
          .then((res) => {
            Indicator.close()
            this.isSetting = false
            this.$set(this.dataList[index], 'IsFavorite', false)
            Toast('已移出收藏夹')
          })
          .catch((err) => {
            Indicator.close()
            this.isSetting = false
            Toast(err.ErrMsg)
          })
      } else {
        // 加入收藏夹
        Indicator.open({
          text: '加入收藏中',
          spinnerType: 'triple-bounce'
        })
        ProductFavoriteAdd({ productId: productID })
          .then((res) => {
            Indicator.close()
            this.isSetting = false
            this.$set(this.dataList[index], 'IsFavorite', true)
            Toast('已加入收藏夹')
          })
          .catch((err) => {
            Indicator.close()
            this.isSetting = false
            Toast(err.ErrMsg)
          })
      }
    }
  },
  filters: {
    filterCoupon(val) {
      if (val) {
        let pattern = /\D*([\d+.*\d*]+)\D*([\d+.*\d*]*)\D*/gi
        if (pattern.test(val)) {
          if (RegExp['$2']) {
            return RegExp['$2']
          } else if (RegExp['$1']) {
            return RegExp['$1']
          } else {
            return val
          }
        } else {
          return val
        }
      } else {
        return val
      }
    },
    compressImgUrl(val) {
      if (/youp-read/g.test(val)) return val + '!sohoUpyun'
      else return val
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.hot-main {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 3% 2% 0 2%;
  font-size: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.hot-main .shopCard {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50%;
}
.hot-block {
  width: 96%;
}
.cnt-list-item {
  position: relative;
  background: #fff;
  border-radius: 6px;
  margin: 0 0 4% 0;
  // border: 1px solid #fefefe;
  overflow: hidden;
}
.cnt-list-item .item-img {
  position: relative;
}
.cnt-list-item .item-img img {
  display: block;
  width: 100%;
  height: 200px;
  background: #ffffff;
  /* min-height: 140px; */
}
.cnt-list-item .item-title {
  width: 100%;
  box-sizing: border-box;
  margin: 4% 0 12px;
  padding: 0 vw(9);
  height: vw(38);
  font-size: vw(14);
  color: #333;
  /* overflow: hidden; */
  text-align: left;
  /* text-overflow: -o-ellipsis-lastline; */
}
.item-title .txt {
  flex-grow: 1;
  max-height: 3em;
  vertical-align: middle;
  text-overflow: ellipsis;
  white-space: normal;
}
.item-title .icon-tm {
  color: #fff;
  background: #dd2727;
  padding: 0 3px;
  font-size: 12px;
  border-radius: 3px;
  margin-right: 2px;
}
/* price */
.through {
  padding-left: 0;
}
.cnt-list-item .item-price {
  width: 100%;
  box-sizing: border-box;
  padding: 0 vw(9) 4%;
}
.item-price .unsearch-through {
  font-size: vw(13);
  color: #ababab;
  text-decoration: line-through;
  margin-right: vw(5);
}
.item-price .i-price {
  text-align: left;
  color: #f23030;
}
.flex {
  display: flex;
}
.i-price .unserch-p {
  align-items: flex-end;
  margin-top: 8px;
}
.unserch-yuan {
  font-style: normal;
  font-size: vw(11);
  font-style: normal;
}
.unserch-money {
  font-size: vw(20);
  line-height: vw(20);
}
.item-tag {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
/* 收藏图标 */
/* .remind-icon{
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 4%;
    bottom: 3%;
    color: #999;
    background: #DEDEDE;
    border-radius: 50%;
  }
  .remind-icon:active{
    opacity: 0.8;
  }
  .remind-icon.active{
    color: #FF6700;
    background: #FFE8D7;
  } */
/* 更多icon */
.more-icon {
  position: absolute;
  right: 2%;
  bottom: 3%;
  color: #999;
  width: 32px;
  text-align: end;
  border-radius: 20px;
}
.more-icon .iconfont:active {
  color: #ccc;
}
/* 屏蔽、收藏层 */
.operate-mask {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.4);
}
.operate-mask .operate-icon {
  height: 45px;
  width: 45px;
  word-break: break-all;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 5px 1px rgba(253, 246, 246, 0.2);
  font-size: 12px;
}
.operate-icon:active {
  background: #eee;
}
.operate-icon .iconfont {
  font-size: 18px;
}
/* 补贴专区 */
.unsearch_coupons {
  display: flex;
  align-items: center;
  color: #f23030;
  background-color: #fdebe7;
  display: inline-block;
  font-size: vw(12);
  font-weight: 400;
  border-radius: 3px;
  height: vw(18);
  padding: 0 vw(4);
}
.unsearch_coupons > span {
  // margin: 0 6px;
  display: inline-block;
}
.un-search-tip {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  background: #f23030;
  box-shadow: 0 0 5px 0 #f23030;
}
/* 平台无商品 */
.plat-without {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  margin: 1% auto 3% auto;
  padding: 2% 4% 2% 2%;
  box-sizing: border-box;
  box-shadow: 0 0 8px 0 #e4e1e1;
  border-radius: 25px;
  background: #fff;
  color: #999;
}
.plat-without .iconfont {
  font-size: 28px;
  color: #f96267;
  flex-shrink: 0;
}
img[lazy='loading'] {
  width: 100%;
  height: auto;
  background: #fff;
}
@media screen and (max-height: 568px) {
  .cnt-list-item .item-img img {
    height: 100%;
  }
  .unsearch_coupons > span {
    margin: 0;
  }
}
</style>
